import { Component, OnInit } from '@angular/core';
import { Config } from '../../config/config';
import { StaticDataService } from '../../service/static-data.service';
import * as $ from 'jquery';
import { StaticViewDataService } from '../../service/static-view-data-service.service';
import { SharedDataService } from '../../service/shared-data.service';
import { RestDataService } from '../../service/rest-data.service';
import { SnotifyService } from 'ng-snotify';
import { Router } from '@angular/router';
@Component({
  selector: '.leftMenu',
  templateUrl: './left-menu.component.html',
  styleUrls: ['./left-menu.component.scss']
})
export class LeftMenuComponent implements OnInit {
  isEnableStockModule: boolean;
  isEnableGoogleTrends: boolean;
  isEnableCompitionData:boolean;
  isEnableTwitterTrend: boolean;
  isEnableCricketAutoLiveBlog: boolean;
  constructor(
    public config: Config,
    private sharedService: SharedDataService,
    private restService:RestDataService,
    private snotify: SnotifyService,
    private router: Router
  ) {
    this.getUserPermission();
    this.buttons = StaticViewDataService.Left_Menu_View.buttons;
   this.sharedService.domainIdSubject.subscribe(data=>{
      this.selectedDomain = data;
    })
  }

    name: string;
    nameArray: string[];
    inits: string;
    initsArray: string[];
    profileImageUrl = null;
    role: string;
    userDomains = [];
    selectedDomain: any;
    buttons;
    
  
  ngOnInit() {
    const token =  JSON.parse(localStorage.getItem(StaticDataService.tokenLiteral));
    this.selectedDomain = sessionStorage.getItem(StaticDataService.domainLiteral);
    this.userDomains = JSON.parse(localStorage.getItem(StaticDataService.domains_all));
    this.profileImageUrl = token.user.pictureUrl;
    this.name = token.name;
    this.nameArray = this.name.split(' ');
    this.initsArray = this.name.split(' ');
    this.name = '';
    this.inits = '';
    this.role = token.user.domainPermissions[this.selectedDomain].role.replace('ROLE_', '').replace('_', ' ');
    
    for (const i in this.initsArray) {
      if (parseInt(i, 10) < 2) {
        if (/^[a-zA-Z0-9]*$/.test(this.nameArray[i]) === true) {
          this.name += this.nameArray[i] + ' ';
          this.inits += this.initsArray[i].charAt(0).toUpperCase();
        }
      }
    }
    this.loadMiscModule();
    this.sharedService.configLoaded.subscribe(res=>{
      if(res){
        this.loadMiscModule()
      }
    })
  }

  loadMiscModule(){
    if(this.restService.userDetail.enableStockModule){
      this.isEnableStockModule = this.restService.userDetail.enableStockModule && this.sharedService.isdomainConfig('module','isStockEnable');
    }
    if(this.restService.userDetail.enableCricketAutoLiveBlog){
      this.isEnableCricketAutoLiveBlog = this.restService.userDetail.enableCricketAutoLiveBlog && this.sharedService.isdomainConfig('module','isCricketAutoLiveBlog');
    }
    this.isEnableTwitterTrend = this.sharedService.isdomainConfig('feeds','showTwitterTrend');
    this.isEnableGoogleTrends = this.sharedService.isdomainConfig('module','isGoogleTrendsEnable');
    this.isEnableCompitionData = this.sharedService.isdomainConfig('feeds','showCompetitionData');
  }

  leftMenuButtonClick(data){
    if(data.name==='VideoCMS'){
      this.snotify.clear()
    }
  }

  onDomainChange($event) {
    //tenant name required for GA
    let allTenantData=JSON.parse(localStorage.getItem(StaticDataService.allDomains));
    let index;
    let tenantName;
    this.selectedDomain = $event.target.value;
    index=allTenantData.findIndex((value)=>value.id== this.selectedDomain);
    tenantName=allTenantData[index].name
    sessionStorage.setItem(StaticDataService.domainLiteral, this.selectedDomain);
    sessionStorage.setItem(StaticDataService.tenantName, tenantName);

    window.location.reload();
  }

  changeDropdownView() {
   return $('.mainContainer').hasClass('storyEditor');
  }

  getUserPermission(){
    let userPermission= this.restService.tokenParse();
    let tempButtons;
    this.sharedService.setConfig();
    setTimeout(e =>{
    if(userPermission){
      console.log('userPermission',this.restService.userDetail);
      tempButtons = StaticViewDataService.Left_Menu_View.buttons;
      if(this.restService.userDetail && (this.restService.userDetail.reportsPermission || this.restService.userDetail.videoCMSPermission || 
        this.sharedService.isdomainConfig('story','enableMicrosite') || this.sharedService.isdomainConfig('feeds','showTranslationFeed')
        || this.sharedService.isdomainConfig('feeds','showEnglishTranslationFeed'))) {
        if (this.restService.userDetail.reportsPermission) {
          let index = tempButtons.findIndex((value) => value.name == 'Reports');
          tempButtons[index]['enable'] = this.restService.userDetail.reportsPermission;
        }
        if (this.restService.userDetail.videoCMSPermission) {
          let index = tempButtons.findIndex((value) => value.name == 'VideoCMS');
          tempButtons[index]['enable'] = this.restService.userDetail.videoCMSPermission;
        }
        if (this.restService.userDetail.educationModulePermission) {
          let index = tempButtons.findIndex((value) => value.name == 'Education');
          tempButtons[index]['enable'] = this.restService.userDetail.educationModulePermission;
        }
        if (this.restService.userDetail.entertainmentModulePermission) {
          let index = tempButtons.findIndex((value) => value.name == 'Entertainment');
          tempButtons[index]['enable'] = this.restService.userDetail.entertainmentModulePermission;
        }
        if (this.sharedService.isdomainConfig('story','enableMicrosite')) {
          let index = tempButtons.findIndex((value) => value.name == 'Microsite');
          tempButtons[index]['enable'] = true;
        }
      if(this.sharedService.isdomainConfig('feeds','showTranslationFeed') || this.sharedService.isdomainConfig('feeds','showEnglishTranslationFeed')) {
        let index = tempButtons.findIndex((value) => value.name == 'Translated Feeds');
        tempButtons[index]['enable'] = true;
      }
      if(this.sharedService.isdomainConfig('module','isGoogleTrendsEnable')) {
        let index = tempButtons.findIndex((value) => value.name == 'Google Trends');
        tempButtons[index]['enable'] = true;
      }
      if(this.restService.userDetail && this.restService.userDetail.analyticsPermission){
        let index=tempButtons.findIndex((value)=>value.name=='Analytics');
        tempButtons[index]['enable']=this.restService.userDetail.analyticsPermission;
      }
      this.buttons = tempButtons;
    }
    else{
      this.buttons = StaticViewDataService.Left_Menu_View.buttons;
    }
  }},1000);
  }

  routeToModule(module){
    this.router.navigate(['/dash/misc/stock'])
  }
}
